<template>
    <transition name="fade">
        <div v-if="visible" class="overlay confirm-overlay">
            <div class="modal" :class="{ confirming: isConfirming }">
                <!-- Glow layer -->
                <div class="modal-glow"></div>

                <!-- Icon -->
                <div class="icon">ⓘ</div>

                <!-- Message -->
                <p class="message">{{ message }}</p>

                <!-- Actions -->
                <div class="actions">
                    <button class="cancel" :disabled="isConfirming" @click="cancel">
                        Hủy
                    </button>

                    <button class="confirm" :disabled="isConfirming" @click="confirm">
                        <span>Xác nhận</span>
                        <span class="shine"></span>
                    </button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script setup>
    import { ref, onMounted, onUnmounted } from 'vue'
    import { EventBus } from '@/utils/eventBus'

    const visible = ref(false)
    const message = ref('')
    const isConfirming = ref(false)

    function showConfirm(msg) {
        message.value = msg
        visible.value = true
        isConfirming.value = false
    }

    function confirm() {
        if (isConfirming.value) return

        isConfirming.value = true

        // ⏳ cho hiệu ứng bling chạy xong
        setTimeout(() => {
            visible.value = false
            isConfirming.value = false
            EventBus.emit('confirm:response', true)
        }, 900)
    }

    function cancel() {
        visible.value = false
        EventBus.emit('confirm:response', false)
    }

    onMounted(() => {
        EventBus.on('confirm:show', showConfirm)
    })

    onUnmounted(() => {
        EventBus.off('confirm:show', showConfirm)
    })
</script>

<style scoped>
    /* ===== OVERLAY ===== */
    .overlay {
        position: fixed;
        inset: 0;
        background: radial-gradient(circle at center,
                rgba(0, 0, 0, 0.65),
                rgba(0, 0, 0, 0.85));

        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
    }

    /* ===== FADE ===== */
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.3s ease;
    }

    .fade-enter-from,
    .fade-leave-to {
        opacity: 0;
    }

    /* ===== MODAL ===== */
    .modal {
        position: relative;
        min-width: 320px;
        max-width: 90%;
        padding: 28px 30px 24px;

        border-radius: 18px;
        background: rgba(255, 255, 255, 0.96);
        backdrop-filter: blur(18px);

        text-align: center;
        box-shadow:
            0 30px 80px rgba(0, 0, 0, 0.45),
            0 10px 24px rgba(0, 0, 0, 0.25);

        transform: scale(0.96);
        animation: pop 0.4s cubic-bezier(0.2, 0.9, 0.2, 1) forwards;
        overflow: hidden;
    }

    @keyframes pop {
        to {
            transform: scale(1);
        }
    }

    /* ===== GLOW ===== */
    .modal-glow {
        position: absolute;
        inset: -30%;
        background: radial-gradient(circle,
                rgba(120, 160, 255, 0.45),
                transparent 70%);
        filter: blur(40px);
        opacity: 0;
        transition: opacity 0.4s ease;
        pointer-events: none;
    }

    .modal.confirming .modal-glow {
        opacity: 1;
    }

    /* ===== ICON ===== */
    .icon {
        font-size: 56px;
        line-height: 1;
        color: var(--color-primary);
        margin-bottom: 10px;
    }

    /* ===== MESSAGE ===== */
    .message {
        font-size: 16px;
        font-weight: 500;
        color: #374151;
        margin-bottom: 24px;
        font-style: italic;
    }

    /* ===== ACTIONS ===== */
    .actions {
        display: flex;
        justify-content: center;
        gap: 16px;
    }

    /* ===== BUTTON BASE ===== */
    button {
        position: relative;
        padding: 10px 22px;
        border-radius: 10px;
        border: none;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        overflow: hidden;
    }

    /* ===== CANCEL ===== */
    .cancel {
        background: #2b2b2b;
        color: white;
    }

    /* ===== CONFIRM ===== */
    .confirm {
        background: linear-gradient(135deg,
                var(--color-primary),
                #6f8cff);
        color: white;
        box-shadow:
            0 0 0 rgba(100, 140, 255, 0);
    }

    /* ===== SHINE EFFECT ===== */
    .confirm .shine {
        position: absolute;
        top: 0;
        left: -120%;
        width: 120%;
        height: 100%;
        background: linear-gradient(120deg,
                transparent,
                rgba(255, 255, 255, 0.8),
                transparent);
    }

    /* Khi bấm xác nhận */
    .modal.confirming .confirm {
        box-shadow:
            0 0 18px rgba(120, 160, 255, 0.9),
            0 0 36px rgba(120, 160, 255, 0.6);
    }

    .modal.confirming .confirm .shine {
        animation: shine 0.6s ease forwards;
    }

    @keyframes shine {
        to {
            left: 120%;
        }
    }

    /* Disable khi đang confirm */
    button:disabled {
        cursor: default;
        opacity: 0.85;
    }
</style>